module.exports = __webpack_public_path__ + "img/142.51cb71a7.jpg";